import CardContent from '@mui/material/CardContent';
import Typography from '@mui/material/Typography';
import AreasCardText from '@src/main/ui/components/common/Dashboard/common/fields/areas/AreasCardText';
import DescriptionCardText from '@src/main/ui/components/common/Dashboard/common/fields/description/DescriptionCardText';
import { HighlighFields } from '@src/main/ui/components/common/Dashboard/common/fields/highlighter/HighlighFields';
import KeyTagsCardText from '@src/main/ui/components/common/Dashboard/common/fields/tags/KeyTagsCardText';
import TagsCardText from '@src/main/ui/components/common/Dashboard/common/fields/tags/TagsCardText';
import RefreshDate from '@src/main/ui/components/common/Dashboard/common/footer/RefreshDate/RefreshDate';
import Views from '@src/main/ui/components/common/Dashboard/common/footer/Views/Views';
import { FC } from 'react';
import styles from './DashboardCardShowMoreContent.module.scss';

interface DashboardCardShowMoreContentProps {
  areas: string[];
  keyTags?: string[];
  tags?: string[];
  description?: string;
  refreshDate?: Date;
  views?: number;
  highlighFields?: HighlighFields[];
}

const defaultProps = {
  keyTags: [],
  tags: [],
  description: '',
  refreshDate: undefined,
  views: undefined,
  highlighFields: undefined,
};

const DashboardCardShowMoreContent: FC<DashboardCardShowMoreContentProps> = ({
  areas,
  keyTags = [],
  tags = [],
  description,
  refreshDate,
  views,
  highlighFields,
}) => (
  <CardContent
    sx={{
      paddingTop: 0,
    }}
  >
    <Typography variant="subtitle1" color="text.secondary" lineHeight={1} sx={{ paddingTop: 1 }}>
      <AreasCardText areas={areas} highlighFields={highlighFields} />
    </Typography>
    <Typography
      variant="body2"
      color="iberiaRed.main"
      display="inline"
      fontWeight="bold"
      sx={{ wordSpacing: '3px' }}
    >
      <KeyTagsCardText keyTags={keyTags} highlighFields={highlighFields} />
    </Typography>
    <Typography
      variant="body2"
      display="inline"
      sx={{ paddingLeft: '4px', wordSpacing: '3px' }}
      color="text.secondary"
    >
      <TagsCardText tags={tags} highlighFields={highlighFields} />
    </Typography>
    <div className={styles.dashboardCardShowMoreContent__refreshAndViews}>
      <RefreshDate refreshDate={refreshDate} variant="small" />
      <Views views={views} variant="small" />
    </div>
    <Typography variant="body1" color="text.secondary" sx={{ paddingTop: 1 }}>
      <DescriptionCardText description={description} highlighFields={highlighFields} />
    </Typography>
  </CardContent>
);

DashboardCardShowMoreContent.defaultProps = defaultProps;

export default DashboardCardShowMoreContent;
